import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { EmailService } from "../,,/../../../../debtor-replies/services/email.service";
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-debtor-email-validation-popup',
  templateUrl: './debtor-email-validation-popup.component.html',
  styleUrls: ['./debtor-email-validation-popup.component.scss']
})
export class DebtorEmailValidationPopupComponent implements OnInit {
  email: any = [];

  constructor(
    private emailService: EmailService,
    public dialogRef: MatDialogRef<DebtorEmailValidationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    if(this.data?.emailID){
      this.getReplies(this.data.emailID)
    }
  }

  getReplies(id: string) {
    this.emailService
      .getEmailReplies(id)
      .subscribe((data) => { 
        if (data?.replies) {
          data.replies.sort((a, b) => {
            const dateA = new Date(a.date).getTime();
            const dateB = new Date(b.date).getTime();
            return dateA - dateB;
          });
        }
        this.email = data
      });
  }

  confirm(status) {
    this.dialogRef.close({event: status});
  }

  cancel() {
    this.dialogRef.close();
  }

}
